import { Info, AddressSection, AddressHeader, AddressInfo, AddressSubHeader, LinkWrapper, AddressLink, AddressContentWrapper, PhoneIcon, MailIcon, PinIcon, TourIcon, BookingIcon, StatuteIcon, LinkDescription } from "./styled";
import { StaggeredContainer, StaggeredItem } from "../../animations/staggeredFadeIn";
import { useTranslation } from "react-i18next";
import { ADDRESS_CONFIG } from "./address.config";

const LinkIcon = ({ kind }) => {
    if (kind === "phone") return <PhoneIcon />;
    if (kind === "email") return <MailIcon />;
    if (kind === "maps") return <PinIcon />;
    if (kind === "tour") return <TourIcon />;
    if (kind === "booking") return <BookingIcon />;
    if (kind === "rules") return <StatuteIcon />;
    return null;
};

const Address = ({ variant = "default" }) => {
    const { t } = useTranslation("address");
    const cfg = ADDRESS_CONFIG[variant] ?? ADDRESS_CONFIG.default;

    const renderBlockContent = (block) => {
        if (variant === "default" && block.type === "company") {
            return (
                <Info>
                    {t("default.blocks.contact.info.company")}
                    <br />
                    {t("default.blocks.contact.info.nipLabel")}: {t("default.blocks.contact.info.nipValue")}
                    <br />
                    {t("default.blocks.contact.info.street")}
                    <br />
                    {t("default.blocks.contact.info.city")}
                    <br />
                </Info>
            );
        }

        if (block.type === "textContact") {
            return <Info style={{ whiteSpace: "pre-line" }}>{t(`${variant}.blocks.${block.key}.text`)}</Info>;
        }

        if (block.type === "housesContact") {
            return <Info style={{ whiteSpace: "pre-line" }}>{t("houses.blocks.contact.text")}</Info>;
        }

        if (block.type === "location") {
            return (
                <Info>
                    {t(`${variant}.blocks.${block.key}.name`)}
                    <br />
                    {t(`${variant}.blocks.${block.key}.street`)}
                    <br />
                    {t(`${variant}.blocks.${block.key}.city`)}
                    <br />
                </Info>
            );
        }

        if (block.type === "locationSingle") {
            return (
                <Info>
                    {t(`${variant}.blocks.${block.key}.name`)}
                    <br />
                    {t(`${variant}.blocks.${block.key}.street`)}
                    <br />
                    {t(`${variant}.blocks.${block.key}.city`)}
                    <br />
                </Info>
            );
        }

        return null;
    };

    return (
        <AddressSection id={cfg.sectionId}>
            <StaggeredContainer>
                <StaggeredItem>
                    <AddressHeader>{t(`${variant}.header`)}</AddressHeader>
                </StaggeredItem>

                <StaggeredItem>
                    <AddressContentWrapper>
                        {cfg.blocks.map((block) => (
                            <AddressInfo key={`${variant}-${block.key}`}>
                                <AddressSubHeader>{t(`${variant}.blocks.${block.key}.header`)}</AddressSubHeader>

                                {renderBlockContent(block)}

                                {block.links?.map((link) => {
                                    const opensInNewTab = [
                                        "maps",
                                        "tour",
                                        "booking",
                                        "rules",
                                    ].includes(link.kind);

                                    return (
                                        <LinkWrapper
                                            key={`${link.kind}-${link.href}-${link.textKey}`}
                                            $hasDescription={Boolean(link.descriptionKey)}
                                        >
                                            <AddressLink
                                                href={link.href}
                                                target={opensInNewTab ? "_blank" : undefined}
                                                rel={opensInNewTab ? "noopener noreferrer" : undefined}
                                                title={link.titleKey ? t(link.titleKey) : undefined}
                                            >
                                                <LinkIcon kind={link.kind} />
                                                <span>{t(link.textKey)}</span>
                                            </AddressLink>

                                            {link.descriptionKey && (
                                                <LinkDescription>
                                                    {t(link.descriptionKey)}
                                                </LinkDescription>
                                            )}
                                        </LinkWrapper>
                                    );
                                })}
                            </AddressInfo>
                        ))}
                    </AddressContentWrapper>
                </StaggeredItem>
            </StaggeredContainer>
        </AddressSection>
    );
};

export default Address;